import gql from "graphql-tag"

export const GET_CHATS = gql`
  query chatMessagesByUserAndTimeInterval {
    chatMessagesByUserAndTimeInterval {
      id
      content
      type
      sender {
        id
        name
        company {
          id
          name
        }
      }
      chatRoom {
        id
        client {
          id
          name
          company {
            id
            name
          }
        }
        assistant {
          id
          name
        }
      }
      createdAt
    }
  }
`

export const GET_COMPANIES = gql`
  query Companies {
    companies {
      data {
        id
        name
        area
      }
    }
  }
`

export const GET_USERS = gql`
  query Users {
    users {
      total
      data {
        id
        name
        email
        title
        dept
        role
        areas
        isEnable
        company {
          id
          name
        }
        isPasswordNeedToChange
      }
    }
  }
`
